import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChatCommonService {
  getDurations() {
    return [
      { label: 'Keine Angabe', value: 0 },
      { label: '10 Min.', value: 10 },
      { label: '20 Min.', value: 20 },
      { label: '30 Min.', value: 30 },
      { label: '40 Min.', value: 40 },
      { label: '50 Min.', value: 50 },
      { label: '60 Min.', value: 60 },
      { label: '1:10 Std.', value: 70 },
      { label: '1:20 Std.', value: 80 },
      { label: '1:30 Std.', value: 90 },
      { label: '1:40 Std.', value: 100 },
      { label: '1:50 Std.', value: 110 },
      { label: '2:00 Std.', value: 120 },
      { label: '2:30 Std.', value: 150 },
      { label: '3:00 Std.', value: 180 },
      { label: '3:30 Std.', value: 210 },
      { label: '4:00 Std.', value: 240 },
      { label: '5:00 Std.', value: 300 },
      { label: '6:00 Std.', value: 360 },
    ];
  }

  formatShortCodeInput(value: string): string {
    value = value.replace(/[^a-zA-Z0-9_-]/g, '');
  
    if (!value.startsWith('{')) {
      value = '{' + value;
    }
    if (!value.endsWith('}')) {
      value = value + '}';
    }

    return value;
  }

  formatted(price: any, digits: number = 2, currency: string = 'EUR') {
    price = `${price}`;
    let format: any = {
      style: 'decimal',
      minimumFractionDigits: digits,
    }
    if (currency) {
      format = {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: digits,
      }
    }
    let formattedPrice = new Intl.NumberFormat('de-DE', format).format(parseFloat(`${price.replace(',','.')}`));
    return formattedPrice;
  }

  constructor() { }
}
